export default "__VITE_ASSET__731d1250__"